export const VideoData = {
  tabs: [
    {
      label: 'All Videos',
      id: 1,
    }
  ],
};